import { render } from "./CmpConfiguracionApi.vue?vue&type=template&id=db6de9ec&scoped=true"
import script from "./CmpConfiguracionApi.vue?vue&type=script&lang=js"
export * from "./CmpConfiguracionApi.vue?vue&type=script&lang=js"

import "./CmpConfiguracionApi.vue?vue&type=style&index=0&id=db6de9ec&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db6de9ec"]])

export default __exports__